import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import Checkbox from '@bibliocommons/base-checkbox';
import { bindAll } from '@bibliocommons/utils-react';

import './CheckboxField.scss';

class CheckboxField extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleToggleFilter(checked, { value: filter }) {
    this.props.handleToggleFilter(this.props.fieldId, filter);
  }

  render() {
    const { fieldId, filter } = this.props;
    const applied = filter.get('applied');
    const checkboxId = [fieldId, applied].join('-');

    return (
      <section className="cp-checkbox-field">
        <Checkbox
          checked={applied}
          dataKey="checkbox-field"
          id={checkboxId}
          handleChange={this.handleToggleFilter}
          label={<FormattedMessage id={`${fieldId}.field`} />}
          value={filter}
        />
      </section>
    );
  }
}

CheckboxField.propTypes = {
  filter: ImmutablePropTypes.map.isRequired,
  fieldId: PropTypes.string.isRequired,
  handleToggleFilter: PropTypes.func.isRequired
};

export default CheckboxField;
